<div class="content-wrapper">
    <div class="content-body">

        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="col-md-8 col-lg-6">
            <div class="card-detail" *blockUI="'section-block'">
                <div class="card-detail-body">
                    <div class="d-flex justify-content-between align-items-center">
                        <h2 class="card-title" style="font-style: italic; font-weight: bold;">
                            {{ device?.modelName?.toUpperCase() }} {{ device?.brandName?.toUpperCase() }}
                        </h2>
                        <div class="card-subtitle text-end">
                            <p>{{ device?.typeName }}</p>
                            <p>{{ device?.cratedAt | date: 'dd/MM/yyyy' }}</p>
                        </div>
                    </div>
                    <p class="card-subtitle">
                        Şirket: <strong>{{ device?.companyName }}</strong>
                    </p>
                    <p class="card-subtitle">
                        Yetkili: <strong>{{ device?.name }} {{ device?.lastName }}</strong>
                    </p>
                </div>
                <div class="device-info">
                    <span>Seri Numarası: {{ device?.seriNo }}</span>
                    <!-- <span>Garanti Durumu: {{ device?.isWarrantyStatus ? 'Geçerli' : 'Geçersiz' }}</span>
                    <span>Cihaz Durumu: {{ device?.isDeviceStatus ? 'Aktif' : 'Pasif' }}</span> -->
                    <span>Periyot: {{ device?.period }} (Ay)</span>
                </div>
            </div>
        </div>
    </div>
</div>

<ul ngbNav #nav="ngbNav" class="nav-tabs mt-1">
    <li ngbNavItem>
        <a ngbNavLink>Cihaz Hareketleri</a>
        <ng-template ngbNavContent>
            <div class="card">
                <div class="col-xl-6 col-md-6 col-12 mt-1 mb-1">
                    <button type="button" class="btn btn-success btn-sm ml-2 d-flex align-items-center"
                        (click)="createMovementModal()">
                        Cihaz Hareketi Ekle
                    </button>
                </div>
                <div class="card-body table-responsive">

                    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap"
                        style="cursor: pointer;" [messages]="{ 
                        emptyMessage: 'Veri Yok',
                        totalMessage: 'Toplam', 
                        selectedMessage: 'Seçili'
                    }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
                        [scrollbarH]="true" (activate)="onActivate($event)">

                        <ngx-datatable-column name="İşlem Yapan Kişi" prop="name" [width]="200" class="ellipsis-column">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{row.name}} {{row.lastName}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Tür" prop="typeName" class="ellipsis-column" [width]="150"></ngx-datatable-column>
                        <ngx-datatable-column name="Tarih" class="ellipsis-column">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{row.movementDate | date:'dd.MM.yyyy'}}
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="Açıklama" prop="description" [width]="300">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <div class="wrap-text">
                                    {{ row.description }}
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="#" class="ellipsis-column">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <button type="button" class="btn btn-icon btn-flat-danger" rippleEffect appDelete
                                    controller="devicemovements" [id]="row.id"
                                    (callback)="getByIdDeviceMovements(pageBasic - 1, selectedSize,device?.id)">
                                    <span [data-feather]="'trash'"></span>
                                </button>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-footer>
                            <ng-template ngx-datatable-footer-template>
                                <div class="datatable-footer-inner">
                                    <div class="page-count">
                                        Toplam Veri {{ totalCount }}
                                    </div>

                                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10"
                                        [(page)]="pageBasic" (pageChange)="onPageChange($event,row)">
                                        <ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'"
                                                [size]="18" [class]="'font-weight-bolder'"></span>
                                        </ng-template>
                                        <ng-template ngbPaginationNext>
                                            <span [data-feather]="'chevron-right'" [size]="18"
                                                [class]="'font-weight-bolder'">
                                            </span>
                                        </ng-template>
                                    </ngb-pagination>
                                </div>
                            </ng-template>
                        </ngx-datatable-footer>
                    </ngx-datatable>
                </div>
            </div>
        </ng-template>
    </li>

</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>